import api from '@/api'

const store = {
  getInformation() {
    return api.get(`/store`)
  },
  getShareUrl() {
    return api.get(`/store/share-url`)
  },
  getStoreCellphone() {
    return api.get(`/store/cellphone`)
  },
}

export default store
